import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import App from './App';
import { startThemeWatcher } from './lib/store';

// Before the first React paint: stamps data-theme on <html> from the
// persisted Settings choice and arms the "Follow the time" boundary timer.
startThemeWatcher();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root element not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
